<!-- 设添加黑名单接口内容 -->
<template>
  <div class>
    <right-structure :Pdatas="infoData">
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
import structure from "@/components/commonStructure";

export default {
  name: "",
  components: {
    "right-structure": structure
  },
  props: ["commonUrls"],
  data() {
    return {
      requestBody: {
        parkCode: "2KNTYVWC",
        carCode: "粤YKK123",
        carOwner: "车主",
        reason: "原因",
        specialCarTypeId: 253
      },
      responseCode: {
        data: {
            blacklistId: 1
        },
        message: "业务成功",
        resultCode: 0,
        status: 1
      },
      infoData: {
        explain: "第三方接入系统请求智慧停车开放平台添加某个黑名单车辆",
        t_url: this.commonUrls.test + "addBlackListCar",
        p_url: this.commonUrls.prod + "addBlackListCar",
          precondition: {
            preData: "对接接口-",
            link:  "添加特殊车辆类型",
            url: "addSpecialCarType",
            endData: "，用于获取添加黑名单所需要的specialCarTypeId（如已有请忽略）"
          },
          fitSystem: "VEMS传统停车场，云停车场",
        pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
        Q_params: [
          {
            titleName: null,
            tabledata: [
              { tableHead: "参数名", tdName: "info1" },
              { tableHead: "是否必填", tdName: "info2" },
              { tableHead: "类型", tdName: "info3" },
              { tableHead: "说明", tdName: "info4" }
            ],
            td: [
              {
                info1: "parkCode",
                info2: "是",
                info3: "String",
                info4:
                  "停车场编号，目前只支持一个停车场，对停车场管理系统VIP类型有多个停车场权限情况，未指定的停车场设置对应停车场默认计费规则"
              },
              // { info1: 'vipTypeCode', info2: '否', info3: 'String', info4: 'VIP类型唯一编号，黑名单沿用VIP类型的模型，添加黑名单需指定“VIP类型编号”或“VIP类型名称”' },
              // { info1: 'vipTypeName', info2: '否', info3: 'String', info4: 'VIP类型名称，如果没有对接“新增月卡类型”接口，可以在停车场管理系统预先建好黑名单的VIP类型，然后按“VIP类型名称”添加黑名单' },
              {
                info1: "specialCarTypeId",
                info2: "是",
                info3: "Long",
                info4:
                  "特殊车辆类型id，仅支持通过新特殊车辆类型（addSpecialCarType）创建的特殊车辆类型返回的specialCarTypeId，"
              },
              { info1: "carCode", info2: "是", info3: "String", info4: "车牌" },
              {
                info1: "carOwner",
                info2: "是",
                info3: "String",
                info4: "车主，不填写的话,则默认为该黑名单名称"
              },
              {
                info1: "reason",
                info2: "是",
                info3: "String",
                info4: "黑名单原因"
              },
              {
                info1: "isPermament",
                info2: "否",
                info3: "Integer",
                info4: "是否永久，0否，1是，默认为 1"
              },
              {
                info1: "timePeriod",
                info2: "否",
                info3: "String",
                info4:
                  "黑名单时间段，当isPermament为1永久时忽略此字段，格式为：起始时间-结束时间yyyyMMddHHmmss-yyyyMMddHHmmss"
              },
              {
                info1: "remark1",
                info2: "否",
                info3: "String",
                info4: "备注1"
              },
              {
                info1: "remark2",
                info2: "否",
                info3: "String",
                info4: "备注2"
              },
              {
                info1: "operator",
                info2: "否",
                info3: "String",
                info4: "操作员"
              },
              {
                info1: "operateDate",
                info2: "否",
                info3: "String",
                info4: "操作时间，yyyyMMddHHmmss"
              }
            //   ,
            //   {
            //     info1: "operateTime",
            //     info2: "是",
            //     info3: "String",
            //     info4: "操作时间，yyyy-MM-dd HH:mm:ss"
            //   }
            ]
          }
        ],
        R_params: [
          {
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'blacklistId', info2: '是', info3: 'Long', info4: '黑名单ID，用于取消黑名单'}
            ]
          }
        ],
        codeStatus: [
          {
            titleName: null,
            tabledata: [
              { tableHead: "状态码", tdName: "info1" },
              { tableHead: "说明", tdName: "info2" }
            ],
            td: [
              { info1: "000110", info2: "失败" },
              { info1: "00110000", info2: "失败" },
              { info1: "110000", info2: "失败" }
            ]
          }
        ]
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
 /* @import "../../assets/less/conmon.less"; */
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/blacklist/addBlackListCar.vue